import React from 'react';
import './LandingPage.css';

export default function District() {
  return (
    <main className="container" style={{ padding: 24 }}>
      <h1>District</h1>
      <p>Page to manage districts (placeholder).</p>
    </main>
  );
}
